/** @typedef {import('./context').MobileIslandDockConfig} MobileIslandDockConfig */

import { sortingToMobileSortValue } from '../../utils/mobileSortValue';

export const normalizeLeadItems = (config) => config?.leadItems ?? [];

/** 从 MRT table 状态解析排序标签（供底部岛中岛按钮文案） */
export const getMobileIslandSortMeta = (table, sortOptions, defaultSortValue = 'createdAt:desc') => {
	if (!table?.getState) {
		return { sortValue: defaultSortValue, currentSortLabel: '排序', isDefaultSort: true };
	}
	const sortValue = sortingToMobileSortValue(table.getState().sorting);
	const currentSortLabel = sortOptions.find((option) => option.value === sortValue)?.label ?? '排序';
	const isDefaultSort = sortValue === defaultSortValue;

	return { sortValue, currentSortLabel, isDefaultSort };
};

/** 左岛：Home + 页标（回列表顶） */
export const buildMobileIslandLeadItems = ({ iconComponent, pageTitle, fallbackTitle, scrollToTop }) => [
	{
		key: 'home',
		icon: 'home',
		label: '首页',
	},
	{
		key: 'page',
		iconComponent,
		label: pageTitle ?? fallbackTitle,
		onClick: scrollToTop,
	},
];

/** 右岛：列表关键词搜索（handlersRef 承载 onApplyKeyword / onClearKeyword） */
export const buildMobileIslandSearchConfig = ({ inputId, name, appliedKeyword, handlersRef, placeholder }) => ({
	inputId,
	name: name ?? inputId,
	appliedValue: appliedKeyword ?? '',
	onSubmit: (value, event) => handlersRef.current.onApplyKeyword?.(value, event),
	onDismiss: () => handlersRef.current.onClearKeyword?.(),
	placeholder,
});

/** 中岛：排序按钮 */
export const buildMobileIslandSortAction = ({ handlersRef, currentSortLabel, isDefaultSort, sortOpen, sortAriaControls }) => ({
	key: 'sort',
	icon: 'sort-amount-down',
	label: currentSortLabel,
	onClick: () => handlersRef.current.onOpenSort(),
	active: !isDefaultSort,
	ariaControls: sortAriaControls,
	ariaExpanded: sortOpen,
});

export const getDockConfigSignature = (config) => {
	if (!config) {
		return '';
	}

	return JSON.stringify({
		id: config.id,
		lead: normalizeLeadItems(config).map((item) => ({
			key: item.key,
			label: item.label,
		})),
		actions: (config.actions ?? []).map((action) => ({
			key: action.key,
			label: action.label,
			active: action.active,
			badge: action.badge,
			hidden: action.hidden,
			loading: action.loading,
			disabled: action.disabled,
			ariaExpanded: action.ariaExpanded,
		})),
		search: config.search
			? {
					inputId: config.search.inputId,
					appliedValue: config.search.appliedValue,
					placeholder: config.search.placeholder,
				}
			: null,
	});
};
